import { Flame } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';

type Props = {
  current_streak: number;
  longest_streak: number;
  overall_accuracy: number;
  total_sessions: number;
};

export function MetricTiles({
  current_streak,
  longest_streak,
  overall_accuracy,
  total_sessions,
}: Props) {
  const accuracyPct = Math.round(overall_accuracy * 100);
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <Tile label="Current streak">
        <span className="inline-flex items-center gap-1.5">
          <Flame className="text-streak size-5" />
          {current_streak}d
        </span>
      </Tile>
      <Tile label="Longest streak">
        <span className="inline-flex items-center gap-1.5">
          <Flame className="text-streak size-5" />
          {longest_streak}d
        </span>
      </Tile>
      <Tile label="Accuracy">{accuracyPct}%</Tile>
      <Tile label="Sessions">{total_sessions}</Tile>
    </div>
  );
}

function Tile({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-1 p-4 pt-4">
        <div className="font-display text-2xl font-bold tabular-nums">{children}</div>
        <div className="text-muted-foreground text-xs">{label}</div>
      </CardContent>
    </Card>
  );
}
